var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloud-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.50079 6.09519C4.04344 4.11861 5.85224 2.6665 8.0013 2.6665C10.1504 2.6665 11.9592 4.11861 12.5018 6.09519C14.1254 6.47291 15.3346 7.92817 15.3346 9.6665C15.3346 11.6915 13.693 13.3332 11.668 13.3332H4.33464C2.30959 13.3332 0.667969 11.6915 0.667969 9.6665C0.667969 7.92817 1.87724 6.47291 3.50079 6.09519ZM8.0013 3.99984C6.34653 3.99984 4.97225 5.20629 4.7123 6.78756C4.66309 7.0869 4.418 7.31527 4.11594 7.34324C2.93016 7.45306 2.0013 8.45169 2.0013 9.6665C2.0013 10.9552 3.04597 11.9998 4.33464 11.9998H11.668C12.9566 11.9998 14.0013 10.9552 14.0013 9.6665C14.0013 8.45169 13.0724 7.45306 11.8867 7.34324C11.5846 7.31527 11.3395 7.0869 11.2903 6.78756C11.0303 5.20629 9.65607 3.99984 8.0013 3.99984Z",
    fill: "#393C3E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.8e3213c8331c6a656d9ae195d55b341b.svg";
export { ForwardRef as ReactComponent };